<div class="header">
    <h2>{{ heading }}</h2>
    <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
  </div>
  
  <mat-dialog-content style="min-height: 80%">
    <div class="search-box">
      <input matInput placeholder="Search" [(ngModel)]="searchitem" />
    </div>
  
    <mat-list>
      <mat-list-item
        *ngFor="let item of itemlistArray | search: { servicename: searchitem }"
      >
        <mat-checkbox
          *ngIf="isMultiple"
          [checked]="isSelected(item)"
          (change)="toggleSelection(item)"
          >{{ item.servicename }}</mat-checkbox
        >
        <div
          mat-line
          *ngIf="!isMultiple"
          (click)="selectItem(item)"
        >
          {{ item.servicename }}
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <!-- <button mat-button (click)="toggleSelectionMode()">
      Switch to {{ isMultiple ? 'Single' : 'Multiple' }} Selection
    </button> -->
    <button mat-button (click)="onSubmit()">Done</button>
  </mat-dialog-actions>
  